import clsx from "clsx";

interface FileSizeProps {
  bytes: number;
  className?: string;
}

const UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

export default function FileSize({ bytes, className }: FileSizeProps) {
  const formatSize = (bytes: number): [number, (typeof UNITS)[number]] => {
    if (bytes === 0) return [0, "B"];

    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const size = bytes / Math.pow(1024, i);

    // Round to 1 decimal place for KB and above, no decimals for bytes
    const roundedSize = i === 0 ? Math.round(size) : Math.round(size * 10) / 10;

    return [roundedSize, UNITS[i]];
  };

  const [size, unit] = formatSize(bytes);

  return (
    <span className={clsx("tabular-nums", className)}>
      {size} {unit}
    </span>
  );
}
